export default __webpack_public_path__ + "static/media/login-bg.9f9fb8be.jpeg";